export default {
    meta: {
        title: '项目',
        isEdit: true,
        crumbs: {
            path: ['/setting/store'],
            name: ['项目管理'],
        },
        otherCrumbs: {
            judge: { key: 'from', value: 'select' },
            path: ['/store'],
            name: ['选择项目'],
        },
    },
};
